var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7A91C",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4446 11.5417C26.3878 9.48608 23.0422 9.48608 20.9854 11.5417L16.6367 15.8904L21.574 20.8277C22.5902 19.9815 23.8785 19.4516 25.301 19.4516C26.117 19.4516 26.8934 19.6211 27.5999 19.9238L28.4446 19.001C30.5008 16.9447 30.5008 13.5986 28.4446 11.5417Z",
    fill: "#F7A91C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7542 21.6629L15.81 16.7188L11.5539 20.9791C9.49767 23.0353 9.49767 26.3815 11.5539 28.4383C13.6106 30.4938 16.9953 30.533 19.0521 28.4773L19.9149 27.6104C19.6123 26.9039 19.4428 26.1274 19.4428 25.3115C19.4428 23.9255 19.9467 22.6673 20.7542 21.6629Z",
    fill: "#F7A91C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6133 25.3127C20.6133 27.7011 22.406 29.6504 24.7154 29.9418V20.6836C22.406 20.975 20.6133 22.9241 20.6133 25.3127Z",
    fill: "#F7A91C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 20.6836V29.9418C28.1962 29.6504 29.9889 27.7011 29.9889 25.3127C29.9889 22.9242 28.1962 20.975 25.8867 20.6836Z",
    fill: "#F7A91C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.762f9551bd2d2262fe085365fd9fa0de.svg";
export { ForwardRef as ReactComponent };